export const REPLACE_SDP_PRODUCTS_FILTERS = "REPLACE_SDP_PRODUCTS_FILTERS";
export const SET_SDP_PRODUCTS_FILTERS = "SET_SDP_PRODUCTS_FILTERS";
export const SET_SDP_PRODUCTS_FILTER_BY = "SET_SDP_PRODUCTS_FILTER_BY";
export const RESET_SDP_PRODUCTS_FILTER = "RESET_SDP_PRODUCTS_FILTER";
export const UNSET_SDP_PRODUCTS_FILTER_BY = "UNSET_SDP_PRODUCTS_FILTER_BY";
export const UNSET_SDP_PRODUCTS_FILTERS = "UNSET_SDP_PRODUCTS_FILTERS";
